import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import {
  deleteCustomProperty,
  clearCustomPropertyAction
} from "actions/properties/customPropertyActions";

const CustomPropertyDelete = ({ formId, closeModal, selected }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearCustomPropertyAction());
    };
  }, [dispatch]);

  const handleDelete = e => {
    e.preventDefault();
    dispatch(deleteCustomProperty(selected));
    closeModal();
  };

  return (
    <form
      id={formId}
      onSubmit={e => handleDelete(e)}
      className="form container"
    >
      <div>
        Are you sure you want to delete this custom property? This can not be
        undone.
      </div>
    </form>
  );
};

export default CustomPropertyDelete;
